import { useState } from 'react';
import EmployeeLayout from '../components/EmployeeLayout';
import AttendanceClock from '../../components/attendance/AttendanceClock';
import AttendanceMonth from '../../components/attendance/AttendanceMonth';
import MyLeave from '../../components/attendance/MyLeave';
import { Card, Tabs } from '../../design-system';
import '../../org-admin/styles/Attendance.css';

// The employee's own attendance: one button, their calendar, and their leave.
//
// Tabbed rather than stacked, because the calendar and the day-by-day table are
// two readings of the same month — showing both means scrolling past one to
// reach the other.
const TABS = [
  { key: 'calendar', label: 'My month' },
  { key: 'log', label: 'Daily log' },
];

function EmployeeAttendance() {
  // Bumped on clock in/out so the month re-reads rather than showing a figure
  // that's one action stale.
  const [refreshKey, setRefreshKey] = useState(0);
  const [tab, setTab] = useState('calendar');

  return (
    <EmployeeLayout title="Attendance" subtitle="Clock in, clock out, and manage your leave">
      <div className="att-page">
        <Card>
          <AttendanceClock onChange={() => setRefreshKey((n) => n + 1)} />
          <p className="att-hint">
            Clocking out and back in during the day is how a break is recorded — the gap between
            sessions is your break, and only the time between clock-in and clock-out counts as worked.
          </p>
        </Card>

        <Tabs tabs={TABS} active={tab} onChange={setTab} />

        {tab === 'calendar' && <MyLeave refreshKey={refreshKey} />}
        {tab === 'log' && <AttendanceMonth refreshKey={refreshKey} title="My daily report" />}
      </div>
    </EmployeeLayout>
  );
}

export default EmployeeAttendance;
